var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.safeHtml)?_c('el-scrollbar',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('div',{ref:"content",staticClass:"progress-domain-meta",domProps:{"innerHTML":_vm._s(_vm.safeHtml)},on:{"click":_vm.toggleGroup,"keydown":_vm.onKeydown}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }